import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { MediaBreakPointUp } from '@lean-body/components/styles';
import { Button, ButtonType } from '@lean-body/components/atoms/button';
import { ZIndex } from '../constants';
export const GoalMatchingAssessmentResultButtons = ({ primaryText, secondButtonText, onClickPrimary, onClickSecondButton, classObject, }) => {
    return (React.createElement("div", { className: css(styles.buttons, classObject) },
        onClickSecondButton && (React.createElement(Button, { className: css(styles.secondButton), onClick: onClickSecondButton, buttonType: ButtonType.secondary, isRadius: true }, secondButtonText)),
        React.createElement(Button, { className: css(styles.primaryButton), onClick: onClickPrimary, buttonType: ButtonType.primary, isRadius: true }, primaryText)));
};
const styles = StyleSheet.create({
    buttons: {
        display: 'flex',
        alignItems: 'flex-end',
        gap: 16,
        position: 'fixed',
        width: 'calc(100% - 32px)',
        bottom: 0,
        left: 16,
        margin: '16px auto',
        zIndex: ZIndex.GoalMatchingAssessmentButton,
        [MediaBreakPointUp.MD]: {
            width: 343,
            left: 0,
            position: 'relative',
        },
    },
    secondButton: {
        width: '33%',
        paddingLeft: 0,
        paddingRight: 0,
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '160%',
        letterSpacing: 1.28,
        height: 48,
        padding: 0,
    },
    primaryButton: {
        flex: 1,
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '160%',
        letterSpacing: 1.28,
        height: 48,
        padding: 0,
    },
});
